<template>
    <div>

      <Button
        :size="15"
        color="#33BDFF"
        colorText="#ffffff"
        tooltip="Reemplazar Según filtro"
        icon="fa fa-exchange-alt"
        round
        :width="30"
        class="mt-2 mb-3 mr-2"
        translate
        @click.native="showModalValidation();"
      />
      <ui-modal
        ref="modal"
        size="small"
        class="modal-buscar-reemplazar-acuerdos-lineas"
        title="Buscar y Reemplazar"
        @close="ActionSetZindexTablaModal(false);ActionSetZindexModal(false);"
      >
        <!-- Cuerpo -->
        <div>
          <!-- Campo en donde buscar -->
          <div class="d-flex">
            <ui-select
              label="Campo en donde Buscar :"
              class="w-100 mr-2 mt-3"
              :keys="{ value: 'id', label: 'name' }"
              placeholder="Seleccione"
              :options="listaCampos"
              @change="changeFormatField();"
              v-model="dataCampoParaBuscar"
            ></ui-select>
          </div>
          <!-- Valor a buscar  -->
          <div v-if="dataCampoParaBuscar.id === '' || dataCampoParaBuscar.id === 'commercial_margin'" >
            <ui-textbox
              label="Valor a Buscar :"
              class="w-100 mt-3"
              v-mask="marginMask"
              v-model="dataValorCampo"
            ></ui-textbox>
          </div>

        </div>
  
        <!-- Valor a reemplazar -->
  
        <div v-if="dataCampoParaBuscar.id === '' || dataCampoParaBuscar.id === 'commercial_margin'">
          <ui-textbox
            label="Valor a Reemplazar :"
            class="w-100 mt-3"
            v-mask="marginMask"
            v-model="dataValorReemplazar"
          ></ui-textbox>
        </div>
  
        <!-- Footer -->
        <div class="d-flex justify-content-between mt-3">
          <button class="btn btn-default" @click="closeModal('modal')">
            Cerrar
          </button>
          <button
            class="btn btn-outline-success"
            id="buttonRef11"
            @click="filtrarDatos"
          >
            Buscar y Reemplazar
          </button>
        </div>
      </ui-modal>
    </div>
  </template>
  
  <script>
  // Vue
  import Vue from "vue";
  // Vuex
  import { mapActions, mapState } from "vuex";
  // Toast
  import VueToastify from "vue-toastify";
  import UiTextbox from "keen-ui/src/UiTextbox";
  import UiSelect from "keen-ui/src/UiSelect";
  import createNumberMask from "text-mask-addons/dist/createNumberMask";
  
  import "vue2-datepicker/locale/es";
  import "vue2-datepicker/index.css";
  Vue.use(VueToastify);
  
  // UI Modal
  import UiModal from "keen-ui/src/UiModal";
  
  // Constantes
  import {buscarYReemplazarClientesBaseCount, buscarYReemplazarClientesBase } from  "../../../../../constants/lineas" ;
  // Buttom
  import Button from "../../../../common/Button";

  const marginMask = createNumberMask({
    prefix: "",
    suffix: "",
    allowDecimal: true,
    requireDecimal: false,
    includeThousandsSeparator: false,
    decimalSymbol: ".",
    decimalLimit: 2,
    integerLimit: 6,
    allowNegative: true
  });
  
  export default {
    props: ["data","dataInicial","getListaAcuerdosClientes"],
    data() {
      return {
        marginMask,
        dataCampoParaBuscar: {
            id: "",
            name: "Seleccionar"
        },
        dataValorCampo: "",
        dataValorReemplazar: "",
        listaCampos: [
        {
            id: "",
            name: "Seleccionar"
        },  
        {
            id: "commercial_margin",
            name: "Margen Comercial"
          }
        ],
      };
    },
    components: {
      UiModal,
      Button,
      UiTextbox,
      UiSelect
    },
    computed: {
      ...mapState([
        "contenedores",
        "atmosferas",
        "puertos",
        "showAcuerdoClientes"
      ]),
      ...mapState("lineas",["dataListaProducto"]),
    },
    methods: {
        ...mapActions(["ActionSetZindexModal", 'ActionSetZindexTablaModal']),
        
        ...mapActions(["AccionCambiar", "ActionSetLoadingTable","ActionSetClientes","ActionSetNavieras","ActionSetAtmosferas",
                    "ActionSetContenedores","ActionSetCommodity","ActionSetContratos"]),
        ...mapActions("lineas", ["actionSetDataListarTarifasAcuerdosClientesBase"]),

        changeFormatField( ) {
            this.dataValorCampo = "" ;
            this.dataValorReemplazar = "" ;
        },
        showModalValidation(){

          ( this.showAcuerdoClientes )
            ? this.openModal('modal')
            : this.$vToastify.warning(
              "Se deben filtrar datos para poder Buscar y Reemplazar.",
              "!Precaución¡"
            );
        },
        handleOpenChange() {
            this.showTimePanel = false;
        },
        openModal(ref) {
            this.ActionSetZindexModal(true);
            this.ActionSetZindexTablaModal(true);

            this.$refs[ref].open();
        },
        closeModal(ref) {
            this.$refs[ref].close();
        },
        estadoButton(text, estado = true) {
            let buttonRef = document.querySelector("#buttonRef11");
            buttonRef.innerHTML = text;
            buttonRef.disabled = estado;
        },
        cerrarModal() {
            this.ActionSetZindexModal(false);
        },
        async filtrarDatos() {
    
            if( this.data.length === 0 ){
            return this.$vToastify.warning(
                "No hay datos para reemplazar.",
                "Precaución"
            ); ;
            }
    
            if( this.dataCampoParaBuscar.id === undefined || this.dataCampoParaBuscar.id === ""  ){
            return this.$vToastify.error(
                "Campo en donde Buscar no debe quedar vacío.",
                "¡Error!"
                );
            }
    
            if( this.dataValorCampo === undefined || this.dataValorCampo === ""  ){
            return this.$vToastify.error(
                "Campo Valor a Buscar no debe quedar vacío.", "¡Error!"
                );
            }
    
            if( this.dataValorReemplazar === undefined || this.dataValorReemplazar === ""  ){
            return this.$vToastify.error(
                "Campo Valor a reemplazar  no debe quedar vacío.", "¡Error!"
                );
            }
    
            const ids = this.data.map( d => d.data_complementaria.id ) ;
    
            const form = {
              ids,
              field : this.dataCampoParaBuscar.id,
              valorABuscar :  (typeof this.dataValorCampo) === "object" ? this.dataValorCampo.id : this.dataValorCampo,
              valorAReemplazar: (typeof this.dataValorReemplazar) === "object" ? this.dataValorReemplazar.id : this.dataValorReemplazar 
            } ;  
            
            this.estadoButton("Realizando Solicitud...");
    
            try {
              this.$vToastify.loader("Realizando Solicitud...");
      
              const { data } = await buscarYReemplazarClientesBaseCount( form ) ;
              this.$vToastify.stopLoader();
      
              if( data.cantidad === 0 ){
                  this.estadoButton("Buscar y Reemplazar", false);
      
                  return this.$vToastify.error(
                    "No se encontraron registros con los datos ingresados.",
                    "¡Error!"
                  );
              } else {
                  const response = await this.$vToastify.prompt({
                     body: `¡Advertencia! \n  ¿Estás seguro que deseas modificar ${data.cantidad} registros?`,
                     answers: { Sí: true, No: false },
                  });
      
                  if( !response ) return this.estadoButton("Buscar y Reemplazar", false);
              }
    
            } catch (error) {
              this.estadoButton("Buscar y Reemplazar", false);
              this.$vToastify.stopLoader();
              return ;
            }
            
            try {
              this.$vToastify.loader("Realizando Solicitud...");
      
              await buscarYReemplazarClientesBase( form ) ;

              await this.getListaAcuerdosClientes()

              this.dataCampoParaBuscar = {
                  id: "",
                  name: "Seleccionar"
              } ;
              this.dataValorCampo = "" ;
              this.dataValorReemplazar = "" ;
      
              this.$vToastify.stopLoader();
              this.$vToastify.success("Se han reemplazado datos con éxito.", "Realizado");
      
              this.estadoButton("Buscar y Reemplazar", false);
              this.closeModal('modal');
            
            } catch (error) {
              this.$vToastify.error(
                "Hubo un error al actualizar datos, recargue e intente nuevamente.",
                "¡Error!"
              );
              this.estadoButton("Buscar y Reemplazar", false);
              this.$vToastify.stopLoader();
            }
            
        },
    },
  };
  </script>
  
  <style scoped>
  .mx-datepicker{
    margin-left: 0px ;
  }
  </style>
  
